import { render } from "./header-without-login.vue?vue&type=template&id=bd830c9e"
import script from "./header-without-login.vue?vue&type=script&lang=js"
export * from "./header-without-login.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__